import React from 'react';
import { Card, Row, Col, Typography, Alert, Space, Tag } from 'antd';
import { TagOutlined, CalendarOutlined } from '@ant-design/icons';
import { getKindTag } from '../../../utils/campaignUtils';
import { formatFilterDescription } from '../../../utils/dateFilterUtils';

const { Title, Text } = Typography;

const ReviewStep = ({ form, products, groups, tags, generatedMessages, campaignMode, customerSelectionMode, campaignCustomersCount, account }) => {
  // Helper functions for rendering UI elements


  const selectedProductIds = form.getFieldValue('selectedProducts') || [];
  const selectedGroupId = form.getFieldValue('selectedGroup');
  const selectedTagIds = form.getFieldValue('selectedTags') || [];
  const selectedDateFilters = form.getFieldValue('selectedDateFilters') || [];

  return (
    <Card>
      <Title level={4}>Resumo da Campanha</Title>
      <Row>
        <Col span={24}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Card size="small">
              <Row>
                <Col span={8}><Text strong>Nome da Campanha:</Text></Col>
                <Col span={16}>{form.getFieldValue('name')}</Col>
              </Row>
            </Card>
            <Card size="small">
              <Row>
                <Col span={8}><Text strong>Tipo:</Text></Col>
                <Col span={16}>{getKindTag(form.getFieldValue('kind'))}</Col>
              </Row>
            </Card>
            
            {form.getFieldValue('kind') === 'follow_up' && (
              <Card size="small">
                <Row>
                  <Col span={8}><Text strong>Objetivo do Follow Up:</Text></Col>
                  <Col span={16}>{form.getFieldValue('followUpObjective') || 'Não especificado'}</Col>
                </Row>
              </Card>
            )}
            
            {form.getFieldValue('kind') === 'offer' && (
              <Card size="small">
                <Row>
                  <Col span={8}><Text strong>Percentual de Desconto:</Text></Col>
                  <Col span={16}>{form.getFieldValue('discountPercentage') || 0}%</Col>
                </Row>
              </Card>
            )}
            
            {form.getFieldValue('kind') === 'offer' && (
              <>
                {campaignMode === 'products' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Produtos Selecionados:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          const selectedProductsCount = selectedProductIds.length;
                          
                          if (selectedProductsCount === 0) {
                            return 'Nenhum produto selecionado';
                          }
                          
                          // Encontrar os nomes dos produtos
                          const selectedProducts = products
                            .filter(p => selectedProductIds.includes(p.id))
                            .map(p => p.name);
                          
                          return (
                            <>
                              <div>{selectedProductsCount} produtos selecionados</div>
                              <div style={{ marginTop: 8 }}>
                                {selectedProducts.join(', ')}
                              </div>
                            </>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                ) : (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Grupo Selecionado:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          if (!selectedGroupId) {
                            return 'Nenhum grupo selecionado';
                          }
                          
                          const selectedGroup = groups.find(g => g.id === selectedGroupId);
                          return selectedGroup ? selectedGroup.name : 'Carregando...';
                        })()}
                      </Col>
                    </Row>
                  </Card>
                )}
                
                {customerSelectionMode === 'direct' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Clientes Selecionados:</Text></Col>
                      <Col span={16}>
                        {form.getFieldValue('selectedCustomers')?.length || 0} clientes selecionados
                      </Col>
                    </Row>
                  </Card>
                ) : customerSelectionMode === 'tags' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Seleção por Tags:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          const selectedTagsCount = selectedTagIds.length;
                          
                          if (selectedTagsCount === 0) {
                            return 'Nenhuma tag selecionada';
                          }
                          
                          // Encontrar os nomes das tags
                          const selectedTags = tags
                            ?.filter(t => selectedTagIds.includes(t.id))
                            .map(t => t.name) || [];
                          
                          return (
                            <>
                              <div>
                                <TagOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                                {selectedTagsCount} tags selecionadas
                              </div>
                              
                              <div style={{ marginTop: 8 }}>
                                {selectedTags.map(tagName => (
                                  <Tag key={tagName} color="green">{tagName}</Tag>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                ) : customerSelectionMode === 'date_filters' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Filtros de Data:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          const filtersCount = selectedDateFilters.length;
                          
                          if (filtersCount === 0) {
                            return 'Nenhum filtro aplicado';
                          }
                          
                          return (
                            <>
                              <div>
                                <CalendarOutlined style={{ color: '#ff7a00', marginRight: 8 }} />
                                {filtersCount} filtro{filtersCount !== 1 ? 's' : ''} aplicado{filtersCount !== 1 ? 's' : ''}
                              </div>
                              
                              <div style={{ marginTop: 8 }}>
                                {selectedDateFilters.map((filter, index) => (
                                  <Tag key={index} color="orange" style={{ marginBottom: 4 }}>
                                    {formatFilterDescription(filter)}
                                  </Tag>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                ) : null}
              </>
            )}
            
            {form.getFieldValue('kind') === 'follow_up' && (
              <>
                {customerSelectionMode === 'direct' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Clientes Selecionados:</Text></Col>
                      <Col span={16}>
                        {form.getFieldValue('selectedCustomers')?.length || 0} clientes selecionados
                      </Col>
                    </Row>
                  </Card>
                ) : customerSelectionMode === 'tags' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Seleção por Tags:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          const selectedTagsCount = selectedTagIds.length;
                          
                          if (selectedTagsCount === 0) {
                            return 'Nenhuma tag selecionada';
                          }
                          
                          // Encontrar os nomes das tags
                          const selectedTags = tags
                            ?.filter(t => selectedTagIds.includes(t.id))
                            .map(t => t.name) || [];
                          
                          return (
                            <>
                              <div>
                                <TagOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                                {selectedTagsCount} tags selecionadas
                              </div>
                              
                              <div style={{ marginTop: 8 }}>
                                {selectedTags.map(tagName => (
                                  <Tag key={tagName} color="green">{tagName}</Tag>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                ) : customerSelectionMode === 'date_filters' ? (
                  <Card size="small">
                    <Row>
                      <Col span={8}><Text strong>Filtros de Data:</Text></Col>
                      <Col span={16}>
                        {(() => {
                          const filtersCount = selectedDateFilters.length;
                          
                          if (filtersCount === 0) {
                            return 'Nenhum filtro aplicado';
                          }
                          
                          return (
                            <>
                              <div>
                                <CalendarOutlined style={{ color: '#ff7a00', marginRight: 8 }} />
                                {filtersCount} filtro{filtersCount !== 1 ? 's' : ''} aplicado{filtersCount !== 1 ? 's' : ''}
                              </div>
                              
                              <div style={{ marginTop: 8 }}>
                                {selectedDateFilters.map((filter, index) => (
                                  <Tag key={index} color="orange" style={{ marginBottom: 4 }}>
                                    {formatFilterDescription(filter)}
                                  </Tag>
                                ))}
                              </div>
                            </>
                          );
                        })()}
                      </Col>
                    </Row>
                  </Card>
                ) : null}
              </>
            )}

            {/* Show customer count for all campaign types */}
            {form.getFieldValue('kind') && (
              <Card size="small">
                <Row>
                  <Col span={8}><Text strong>Clientes que receberão mensagens:</Text></Col>
                  <Col span={16}>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#1890ff' }}>
                      {campaignCustomersCount} clientes
                    </div>
                    {form.getFieldValue('kind') === 'reactivation' && (
                      <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
                        (Clientes inativos há mais de {account?.inactiveCustomerDays || 30} dias)
                      </div>
                    )}
                    {form.getFieldValue('kind') === 'activation' && (
                      <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
                        (Clientes sem pedidos anteriores)
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            )}

            {/* Show WhatsApp verification setting */}
            <Card size="small">
              <Row>
                <Col span={8}><Text strong>Campanha apenas para clientes com WhatsApp validado:</Text></Col>
                <Col span={16}>
                  <Text style={{ 
                    fontSize: '14px', 
                    fontWeight: 'bold', 
                    color: account?.onlyVerifiedWhatsappCampaigns ? '#52c41a' : '#ff4d4f' 
                  }}>
                    {account?.onlyVerifiedWhatsappCampaigns ? 'Sim' : 'Não'}
                  </Text>
                </Col>
              </Row>
            </Card>

            {/* Daily limit information */}
            {account && (
              <Card size="small" style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}>
                <Row>
                  <Col span={8}><Text strong>Limite Diário de Mensagens:</Text></Col>
                  <Col span={16}>
                    <div style={{ fontSize: '14px' }}>
                      <div>
                        <Text strong style={{ color: '#52c41a' }}>
                          {account.dailyMessagesRemaining || 0}
                        </Text>
                        <Text> mensagens disponíveis hoje</Text>
                      </div>
                      <div style={{ fontSize: '12px', color: '#666', marginTop: 4 }}>
                        Limite diário: {account.dailyMessageLimit || 200} mensagens
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        Já enviadas hoje: {account.messagesSentToday || 0} | 
                        Agendadas para hoje: {account.messagesScheduledForToday || 0}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            )}

            {/* Show scheduling information if messages exceed daily limit */}
            {account && campaignCustomersCount > (account.dailyMessagesRemaining || 0) && (
              <Alert
                type="warning"
                showIcon
                message="Agendamento Automático"
                description={
                  <div>
                    <div>
                      <Text strong>{Math.min(campaignCustomersCount, account.dailyMessagesRemaining || 0)}</Text>
                      <Text> mensagens serão enviadas hoje</Text>
                    </div>
                    <div>
                      <Text strong>{campaignCustomersCount - (account.dailyMessagesRemaining || 0)}</Text>
                      <Text> mensagens serão agendadas para os próximos dias (às 9h da manhã)</Text>
                    </div>
                  </div>
                }
                style={{ marginTop: 8 }}
              />
            )}
            
          </Space>
        </Col>
      </Row>
      
      <Alert
        style={{ marginTop: 16 }}
        message="Revisão"
        description="Revise os detalhes da campanha antes de enviá-la. Após o envio, as mensagens serão processadas e estarão prontas para serem enviadas."
        type="info"
        showIcon
      />
    </Card>
  );
};

export default ReviewStep;